// @flow
import * as React from 'react';
import { SEARCH_RADIUSES } from 'utils/constants';
import { getter, compose } from 'utils/functional';
import Select from 'components/Select';

const radiusOptionsWithCountry = SEARCH_RADIUSES[USER_LOCALE].map(
  ({ id, name }) => ({
    value: id,
    label: name
  })
);

const radiusOptions = radiusOptionsWithCountry.filter(
  option => option.value !== 'country'
);

const SearchRadiusSelector = ({
  radius,
  setSearchRadius,
  includeCountry
}: {
  radius: string,
  setSearchRadius: string => void,
  includeCountry: boolean
}) => (
  <Select
    label={getText('Search radius')}
    name="radius"
    value={radius}
    options={includeCountry ? radiusOptionsWithCountry : radiusOptions}
    onChange={compose(
      setSearchRadius,
      getter('value')
    )}
    data-qa-id="search-radius-selector"
  />
);

export default SearchRadiusSelector;
